export default __webpack_public_path__ + "static/media/keuken_home.7427f6c0.jpg";